import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import UserAddBot from "../Modal/UserAddBot";
import { useTranslation } from "react-i18next";

const UserCreateBot = () =>{
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const user = localStorage.getItem("id");
  const [addModalShow, setAddModalShow] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [botList, setBotList] = useState([]);
  const [isNoBot, setIsNoBot] = useState(0);
  const {t} = useTranslation();

  function createBot(data) {
    if (data && user) {
      setLoading(true);
      axios
        .put(
          `${API_URL}/${API_VERSION}/bot`,
          {
            name:data,
            user,
            settings: {
              model: "gpt-3.5-turbo",
              temperature: 0,
              messageLimit: 100,
              visibility: "public"
            },
            chatInterface: {
              logoName: "https://seekicon.com/free-icon-download/chat_7.svg"
            }
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          setLoading(false);
          setAddModalShow(false);
          setType("Success");
          setMessage(t("Your bot is created."));
          setShowAlert(true);
          navigate(`/my-bots/${response.data.botId}`);
        })
        .catch((error) => {
          setLoading(false);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  const getAllBots = () => {
    setLoading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/bot/user/${user}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
      .then((response) => {
        setLoading(false);
        setBotList(response.data);
        setIsNoBot(1);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went to wrong."));
        setShowAlert(true);
      });
  };

  useEffect(() => {
    if (user) {
      getAllBots();
    }
  }, [user]);

    return(
      <>
      <section className="userbots_main hasbanner">
      {!!isNoBot && botList.length===0 && 
          <section className="create_bot_main">
              <Container className="mb-5">
                <Row className="justify-content-center">
                      <Col lg={8}>
                        <div className="create_bot d-flex flex-column">
                            <strong className="createText">{t("Its look like you do not have any active")} <span>{t("chatbot")}</span>.</strong>
                            <small>{t("Start creating your first bot.")}</small>
                            <Link className="userbutton mt-2 py-4 px-5" onClick={()=>setAddModalShow(true)}> {t("Create A Bot")}</Link>
                        </div>
                      </Col>
                </Row>
              </Container>
          </section>
      }                   
      </section>
        <UserAddBot
          show={addModalShow}
          onHide={() => setAddModalShow(false)}
          createBot={createBot}
          getBots={getAllBots}
        />
      </>
        
    )
}
export default UserCreateBot;
